export default {
    RECURRENT: 'RECURRENT',
    SINGLE: 'SINGLE'
}